import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  base: {
    color: 'primary.500',
  },
});
